import { render } from "./functionalLocation.vue?vue&type=template&id=54949d27&scoped=true"
import script from "./functionalLocation.vue?vue&type=script&lang=js"
export * from "./functionalLocation.vue?vue&type=script&lang=js"

import "./functionalLocation.vue?vue&type=style&index=0&id=54949d27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54949d27"]])

export default __exports__